import { type IConfig } from '@cian/config/shared';

import { fetchQuickLinksSafe } from './fetchQuickLinks';

export async function fetchQuickLinksSafeIfNeeded(
  context: Parameters<typeof fetchQuickLinksSafe>[0] & { config: IConfig },
  parameters: Parameters<typeof fetchQuickLinksSafe>[1],
): Promise<ReturnType<typeof fetchQuickLinksSafe>> {
  const isEnabled = Boolean(context.config.get<boolean>('online-marketing.SeoCrossLinksQuickLinks.Enabled'));

  if (!isEnabled) {
    return null;
  }

  return fetchQuickLinksSafe(context, parameters);
}
